import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  phone: string;
};

export const sendAuthorisationCodeOnPhone = async (params: Params) => {
  const fetchURL = getM8AuthURL('sendAuthorisationCodeOnPhone');

  const body = new FormData();
  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
